var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 159,
    viewBox: "0 0 181 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7966 157.041C71.9067 151.119 55.3009 126.217 50.4417 125.55C45.7063 124.901 28.8784 150.081 24.3267 157.041H75.7966Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0923 11.5342V68.9607",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.916 13.0752V68.9603",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.394 43.6572V97.7874",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.317 13.0752V97.7868",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.237 13.0752V70.5018",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1523 19.2324H127.46",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1523 31.9961H130.526",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4941 43.6572H134.278",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.833 56.6416H134.279",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1919 70.7197H131.856",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.992 84.3623H128.995",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0679 16.9863L56.8349 23.0667",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5996 10.5742L67.3025 14.6264",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4482 0.77832L80.8138 8.20803",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.761 96.2543H109.952V65.7968H92.5729V11.8545C85.2486 11.9268 78.0661 13.882 71.7158 17.5321C65.3655 21.1822 60.0609 26.4045 56.3119 32.6969C52.563 38.9894 50.4957 46.1404 50.3088 53.4626C50.122 60.7848 51.8218 68.032 55.2449 74.5075C56.637 77.7484 59.9077 85.6862 63.1828 95.9512C66.2102 105.426 67.7901 114.952 67.7901 116.391C67.7901 116.532 67.7901 116.678 67.7901 116.818C67.7752 117.247 67.8466 117.674 68.0002 118.074C68.1537 118.474 68.3863 118.839 68.6839 119.147C68.9815 119.456 69.3382 119.701 69.7326 119.869C70.127 120.036 70.5511 120.123 70.9797 120.123H115.067C115.495 120.122 115.919 120.035 116.313 119.868C116.708 119.7 117.064 119.454 117.361 119.146C117.659 118.838 117.891 118.473 118.045 118.073C118.199 117.673 118.271 117.247 118.257 116.818C118.257 116.665 118.257 116.52 118.257 116.391C118.248 114.97 119.798 105.627 122.761 96.2543Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1011 18.7385C79.3367 18.1814 80.6042 17.6981 81.8971 17.291",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8823 29.5576C63.8823 29.5576 67.3623 24.0067 75.0098 20.2705",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7983 91.0117C66.3825 96.1869 68.479 103.356 69.2049 107.361C70.4347 114.116 69.6319 117.609 72.2793 118.211",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8599 84.8359C62.8599 84.8359 63.2869 86.2237 63.9743 88.3501",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3182 119.709V78.8887C90.3182 78.8887 92.0261 68.2139 86.4752 68.2139C80.9243 68.2139 81.3513 73.7648 87.7562 79.7427C94.1611 85.7207 103.982 80.1697 105.263 75.4728C106.544 70.7758 103.128 68.6409 100.993 72.4838C98.8581 76.3268 100.993 119.88 100.993 119.88",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.181 119.876H70.104V130.568H116.181V119.876Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.181 133.112H70.104V143.804H116.181V133.112Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.181 130.567H70.104V133.112H116.181V130.567Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.181 146.35H70.104V157.042H116.181V146.35Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.361 129.138H114.786",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.915 129.138H109.713",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.481 142.583H113.519",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7563 142.583H101.212",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0776 142.583H76.9778",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.181 143.805H70.104V146.35H116.181V143.805Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8767 148.694H76.1035V156.905H91.8767V148.694Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112.403 148.694H96.6299V156.905H112.403V148.694Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M126.592 157.043C123.568 154.391 110.66 143.242 106.903 142.952C103.222 142.657 90.1561 153.934 86.6206 157.043H126.592Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M176.427 157.043H180.133",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76514 157.043H172.721",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1 157.043H3.88222",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.97 132.673H157.89V148.215H162.48H168.97H173.565V140.444L168.97 132.673Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M173.566 148.216H168.489V151.747H173.566V148.216Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M149.653 148.04C149.653 148.04 155.204 145.051 153.283 130.106L146.237 126.263L134.068 124.342L123.18 124.769V130.96C123.18 130.96 129.371 136.298 130.012 138.006C130.413 139.175 130.629 140.399 130.652 141.635V147.613L149.653 148.04Z",
    fill: "#D5E6FB",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.282 130.106L149.652 148.04",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M146.239 126.264L142.183 148.04",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.068 124.342L131.079 140.568",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M123.607 130.106C123.607 130.106 130.652 133.095 133.428 135.017C136.203 136.938 135.776 140.995 135.776 140.995",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.989 148.326H124.884V151.102H157.989V148.326Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M164.597 141.209H171.51L167.8 134.804H164.597V141.209Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.531 134.804H160.542V141.209H163.531V134.804Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M145.213 148.216H125.059V153.028H145.213V148.216Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.305 156.963C166.609 156.547 168.14 154.341 167.723 152.037C167.307 149.733 165.101 148.202 162.797 148.618C160.493 149.035 158.962 151.24 159.378 153.545C159.795 155.849 162 157.38 164.305 156.963Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M163.545 155.278C164.91 155.278 166.017 154.171 166.017 152.805C166.017 151.44 164.91 150.333 163.545 150.333C162.18 150.333 161.073 151.44 161.073 152.805C161.073 154.171 162.18 155.278 163.545 155.278Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M131.626 156.972C133.932 156.564 135.47 154.364 135.062 152.058C134.653 149.752 132.453 148.214 130.147 148.622C127.841 149.03 126.303 151.231 126.711 153.536C127.12 155.842 129.32 157.381 131.626 156.972Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130.878 155.278C132.243 155.278 133.35 154.171 133.35 152.805C133.35 151.44 132.243 150.333 130.878 150.333C129.513 150.333 128.406 151.44 128.406 152.805C128.406 154.171 129.513 155.278 130.878 155.278Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M143.984 155.911C145.709 154.327 145.823 151.645 144.239 149.92C142.655 148.195 139.973 148.081 138.248 149.664C136.523 151.248 136.409 153.93 137.993 155.655C139.577 157.38 142.259 157.494 143.984 155.911Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.113 155.278C142.478 155.278 143.585 154.171 143.585 152.805C143.585 151.44 142.478 150.333 141.113 150.333C139.748 150.333 138.641 151.44 138.641 152.805C138.641 154.171 139.748 155.278 141.113 155.278Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M139.727 140.781H129.052C128.286 140.781 127.665 141.403 127.665 142.169V146.652C127.665 147.419 128.286 148.04 129.052 148.04H139.727C140.494 148.04 141.115 147.419 141.115 146.652V142.169C141.115 141.403 140.494 140.781 139.727 140.781Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M122.326 148.04V126.925H126.596V148.04",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 129.722H126.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 133.019H126.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 136.314H126.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 139.616H126.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 142.912H126.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 146.208H126.549",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9218 157.455H29.2358V23.3789L36.9218 32.3159V157.455Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 129.273H36.8495L29.313 121.984H36.8495L29.313 129.273Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 121.801H36.8495L29.313 114.512H36.8495L29.313 121.801Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 114.329H36.8495L29.313 107.04H36.8495L29.313 114.329Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 106.857H36.8495L29.313 99.5684H36.8495L29.313 106.857Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 99.3845H36.8495L29.313 92.0957H36.8495L29.313 99.3845Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 91.9118H36.8495L29.313 84.623H36.8495L29.313 91.9118Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 84.4392H36.8495L29.313 77.1504H36.8495L29.313 84.4392Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 76.9665H36.8495L29.313 69.6777H36.8495L29.313 76.9665Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 69.4939H36.8495L29.313 62.2051H36.8495L29.313 69.4939Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 62.0222H36.8495L29.313 54.7334H36.8495L29.313 62.0222Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 54.5495H36.8495L29.313 47.2607H36.8495L29.313 54.5495Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 47.0769H36.8495L29.313 39.7881H36.8495L29.313 47.0769Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 39.6042H36.8495L29.313 32.3154H36.8495L29.313 39.6042Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6054 39.8051L68.882 37.4609H42.3101L39.0649 39.8051H72.6054Z",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2216 39.6045H8.31836V41.3125H73.2216V39.6045Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8823 37.4612L29.2358 23.3789L42.3104 37.4612",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2411 23.3789L8.31836 39.6047",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4767 43.2334H26.4644V53.4813H42.4767V43.2334Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1377 45.3691H29.7993V48.3581H39.1377V45.3691Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2202 41.3125V59.7245",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M75.655 66.0146H70.9111V71.3905H75.655V66.0146Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9111 66.0148L73.2852 59.375L75.6593 66.0148",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4241 130.887L70.672 147.087L73.234 145.213L65.6932 130.131C65.3544 129.454 64.8332 128.883 64.1883 128.485C63.5435 128.087 62.8004 127.876 62.0424 127.877C61.6945 127.883 61.3545 127.982 61.0575 128.164C60.7605 128.345 60.5171 128.602 60.3523 128.909C60.1875 129.215 60.1073 129.56 60.1199 129.908C60.1326 130.255 60.2376 130.594 60.4241 130.887Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M72.333 143.104L61.7905 150.602C61.7905 150.602 62.7299 154.581 68.8189 154.346C74.9078 154.111 74.6772 147.788 74.6772 147.788L72.333 143.104Z",
    fill: "#093269",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0518 138.185L62.147 129.581C62.7767 129.297 63.4845 129.238 64.1526 129.413C64.8207 129.588 65.4088 129.986 65.8191 130.541C66.0589 130.866 66.2312 131.235 66.3258 131.627C66.4205 132.019 66.4357 132.426 66.3704 132.824C66.3051 133.222 66.1607 133.603 65.9458 133.944C65.7308 134.286 65.4496 134.581 65.1189 134.811L44.226 149.436L43.0518 138.185Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2403 148.728H20.5601V151.772H40.2403V148.728Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6334 140.06H13.5322V147.088H30.6334V140.06Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 132.092H42.9256C43.2654 132.092 43.5912 132.227 43.8314 132.467C44.0717 132.707 44.2066 133.033 44.2066 133.373V147.079H27.1226V133.373C27.1226 133.204 27.1558 133.037 27.2205 132.882C27.2851 132.726 27.3799 132.584 27.4993 132.465C27.6187 132.346 27.7604 132.252 27.9163 132.188C28.0722 132.124 28.2392 132.091 28.4078 132.092Z",
    fill: "#F26531",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3578 157.041H41.3558C42.2403 157.041 43.0885 156.69 43.7139 156.064C44.3393 155.439 44.6907 154.591 44.6907 153.706C44.6907 152.821 44.3395 151.973 43.7142 151.347C43.0889 150.721 42.2407 150.368 41.3558 150.367H13.3578C12.4729 150.368 11.6247 150.721 10.9994 151.347C10.3742 151.973 10.0229 152.821 10.0229 153.706C10.0229 154.591 10.3743 155.439 10.9997 156.064C11.6251 156.69 12.4733 157.041 13.3578 157.041Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5769 157.041H45.5707C46.4555 157.041 47.3042 156.69 47.9303 156.065C48.5564 155.439 48.9087 154.591 48.9098 153.706C48.9098 152.821 48.558 151.971 47.9318 151.345C47.3056 150.719 46.4563 150.367 45.5707 150.367H17.5769C16.6913 150.367 15.842 150.719 15.2158 151.345C14.5896 151.971 14.2378 152.821 14.2378 153.706C14.2389 154.591 14.5912 155.439 15.2173 156.065C15.8434 156.69 16.692 157.041 17.5769 157.041Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2204 147.088H13.5322V149.432H44.2204V147.088Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8613 153.706C19.8613 154.123 19.7376 154.531 19.5058 154.878C19.274 155.225 18.9446 155.495 18.5591 155.655C18.1737 155.814 17.7496 155.856 17.3404 155.775C16.9312 155.693 16.5554 155.493 16.2604 155.198C15.9654 154.903 15.7645 154.527 15.6831 154.118C15.6017 153.708 15.6435 153.284 15.8031 152.899C15.9628 152.513 16.2332 152.184 16.58 151.952C16.9269 151.72 17.3347 151.597 17.7519 151.597C18.3114 151.597 18.8479 151.819 19.2435 152.214C19.6391 152.61 19.8613 153.147 19.8613 153.706Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 155.815C24.5399 155.815 25.4843 154.871 25.4843 153.706C25.4843 152.541 24.5399 151.597 23.375 151.597C22.21 151.597 21.2656 152.541 21.2656 153.706C21.2656 154.871 22.21 155.815 23.375 155.815Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9946 155.815C30.1596 155.815 31.104 154.871 31.104 153.706C31.104 152.541 30.1596 151.597 28.9946 151.597C27.8296 151.597 26.8853 152.541 26.8853 153.706C26.8853 154.871 27.8296 155.815 28.9946 155.815Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M36.727 153.706C36.727 154.123 36.6033 154.531 36.3715 154.878C36.1397 155.225 35.8103 155.495 35.4249 155.655C35.0394 155.814 34.6153 155.856 34.2061 155.775C33.797 155.693 33.4211 155.493 33.1261 155.198C32.8311 154.903 32.6302 154.527 32.5488 154.118C32.4674 153.708 32.5092 153.284 32.6689 152.899C32.8285 152.513 33.0989 152.184 33.4458 151.952C33.7926 151.72 34.2005 151.597 34.6177 151.597C35.1771 151.597 35.7136 151.819 36.1092 152.214C36.5048 152.61 36.727 153.147 36.727 153.706Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3501 153.706C42.3501 154.123 42.2263 154.531 41.9946 154.878C41.7628 155.225 41.4334 155.495 41.0479 155.655C40.6625 155.814 40.2384 155.856 39.8292 155.775C39.42 155.693 39.0442 155.493 38.7492 155.198C38.4542 154.903 38.2533 154.527 38.1719 154.118C38.0905 153.708 38.1323 153.284 38.2919 152.899C38.4516 152.513 38.7219 152.184 39.0688 151.952C39.4157 151.72 39.8235 151.597 40.2407 151.597C40.8001 151.597 41.3367 151.819 41.7322 152.214C42.1278 152.61 42.3501 153.147 42.3501 153.706Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9697 153.706C47.9697 154.123 47.8459 154.531 47.6139 154.878C47.3819 155.225 47.0522 155.496 46.6666 155.655C46.2809 155.815 45.8565 155.856 45.4472 155.775C45.038 155.693 44.6621 155.491 44.3673 155.196C44.0725 154.901 43.8719 154.524 43.791 154.115C43.7101 153.705 43.7525 153.281 43.9128 152.896C44.0731 152.511 44.3441 152.181 44.6915 151.95C45.039 151.719 45.4472 151.596 45.8646 151.597C46.1414 151.597 46.4155 151.651 46.6712 151.757C46.9268 151.863 47.1591 152.019 47.3546 152.215C47.5502 152.411 47.7051 152.643 47.8107 152.899C47.9162 153.155 47.9702 153.429 47.9697 153.706Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3704 132.092C64.3704 131.86 64.3015 131.633 64.1723 131.439C64.043 131.246 63.8594 131.096 63.6446 131.007C63.4298 130.918 63.1934 130.895 62.9656 130.941C62.7377 130.987 62.5284 131.099 62.3644 131.263C62.2003 131.428 62.0888 131.638 62.044 131.866C61.9992 132.094 62.0231 132.33 62.1126 132.545C62.2021 132.759 62.3533 132.942 62.5469 133.071C62.7406 133.199 62.9681 133.267 63.2005 133.266C63.3545 133.266 63.507 133.236 63.6492 133.177C63.7914 133.118 63.9206 133.031 64.0293 132.922C64.138 132.813 64.2241 132.684 64.2826 132.541C64.3412 132.399 64.371 132.246 64.3704 132.092Z",
    fill: "#093269",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6441 133.966H29.2271V141.464H41.6441V133.966Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6465 133.966H34.853V141.464H41.6465V133.966Z",
    fill: "white",
    stroke: "#093269",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/Construction.8e7f0a9122b8a3a7deca18f9d8b49df5.svg";
export { ForwardRef as ReactComponent };